import React, { useContext } from 'react';
import classNames from 'classnames/bind.js';
import { Typography } from '@one-thd/sui-atomic-components';
import { FBTContext } from '../contexts/FBTContext';
import { FBTPlaceholder } from '../FBTPlaceholder.component';
import { RecsProductPod } from './RecsProductPod';
import styles from '../thd-recs-fbt.module.scss';

const cx = classNames.bind(styles);
export const RecsFBT = () => {

  const {
    RecsFbtResponseData,
    RecsFbtResponseDataLoading,
    checkedItems,
    dynamicTitle
  } = useContext(FBTContext);

  if (RecsFbtResponseDataLoading) {
    return (
      <FBTPlaceholder />
    );
  }

  const bundleProducts = RecsFbtResponseData?.products;
  if (!bundleProducts?.length || !bundleProducts[0]?.isAnchor) { return null; }
  const checkedSkus = ({ products }) => {
    return products.map((productObj) => {
      // primary item is a frontEnd model response
      const {
        product: {
          identifiers: {
            itemId
          },
          pricing
        }
      } = productObj;
      // ssr should check the first item
      const checked = typeof window === 'undefined'
        ? true
        : (checkedItems.indexOf(itemId) > -1);

      return {
        pricing,
        itemId,
        checked,
        product: productObj.product,
        type: 'product',
        strategy: productObj.strategy
      };
    });
  };
  // removing product coming from client only product call
  const checkedProductSkus = checkedSkus({ products: [...bundleProducts] });

  return (
    <div className={cx('frequently-bought-together')} data-type="container" data-component="RecsFBT" id="fbt-carousel">
      <meta data-prop="name" content="pip_fbt" />
      <div className="sui-py-4">
        <Typography variant="h2">{dynamicTitle}</Typography>
      </div>
      <RecsProductPod normalizedProducts={checkedProductSkus} itemId={bundleProducts[0]?.product?.itemId} />
    </div>
  );
};
